import axios from 'axios';
import { getContactPhones, getUserBasicInfo, handleError } from './utils';
import { createNotification } from '../actions/notifications';

// Email configurations
const URL_API_WHATS =
	'https://desarrollo-web-323816.uc.r.appspot.com/api/whatsapp/sendTemplateWhatsApp';

const options = {
	method: 'POST',
	headers: {
		'Content-Type': 'application/json',
	},
};

// Generate messages from data parameters
const generateMessageNotification = (data) => {
	const params = data.templateParameters.map(({ text }) => text);
	switch (data.templateName) {
		case 'pilu_alerta2':
			return `Alerta de Retraso en Producción. Este mensaje fue generado porque la orden ${params[0]} se retrasó ${params[1]} día(s) en el área de ${params[2]}. La nueva fecha estimada es ${params[3]}. Consulte a un supervisor de área.`;
		case 'pilu_alerta5':
			return `El operador ${params[0]} del área ${params[1]} reportó el siguiente problema en la orden ${params[2]}: ${params[3]}. Consulte al supervisor de área.`;
		case 'pilu_alerta6':
			return `Se ha creado un nuevo pedido del cliente ${params[0]}. Con número de orden ${params[1]}. Consulte el panel para revisarlo.`;
		case 'pilu_alerta7':
			return `La orden ${params[0]} ha finalizado. Consulte el panel para revisarlo.`;
		case 'pilu_alerta8':
			return `El operador ${params[0]} del área ${params[1]} ha ${params[2]} el pedido ${params[3]}. Consulte el panel para revisarlo.`;
		default:
			return 'Mensaje no válido';
	}
};

// Send email through API.
export const sendWhatsApp = async (
	order,
	user,
	arrRecipients,
	data,
	newNotification = true,
	mapPhoneNumbers = true
) => {
	// TODO: DISCOMMENT THIS WHEN THE PAYMENT IS READY
	// // Get message
	// const message = generateMessageNotification(data);
	// // Filter and handle phones list
	// const phonesList = mapPhoneNumbers
	// 	? getContactPhones(arrRecipients)
	// 	: arrRecipients;

	// if (newNotification && mapPhoneNumbers) {
	// 	// Create notification in Firestore
	// 	createNotification({
	// 		order: {
	// 			id: order?.id,
	// 			number_order: order?.number_order,
	// 			created_by: getUserBasicInfo(order?.created_by),
	// 		},
	// 		user: getUserBasicInfo(user),
	// 		division: order.division,
	// 		message,
	// 		arrRecipients: arrRecipients.map(
	// 			({ first_name, last_name, phone }) => ({
	// 				name: `${first_name} ${last_name}`,
	// 				phone,
	// 			})
	// 		),
	// 		isDone: false,
	// 		template: data.templateName,
	// 	}).catch((error) => handleError(error));
	// }

	// return await axios.post(
	// 	URL_API_WHATS,
	// 	{ ...data, arrRecipients: phonesList },
	// 	options
	// );

	// Temporary response due to payment
	return Promise.resolve({ ok: false, msg: 'API de WhatsApp - Pago' });
};

// Report problem
/*
	pilu_alerta5:
		El operador {{1}} del área {{2}} reportó el siguiente problema en la orden {{3}}:
		{{4}}. *Consulte al supervisor de área.*
*/
export const template1 = (user, area, numberOrder, msg) => ({
	templateName: 'pilu_alerta5',
	templateParameters: [
		{
			type: 'text',
			text: String(user),
		},
		{
			type: 'text',
			text: String(area),
		},
		{
			type: 'text',
			text: String(numberOrder),
		},
		{
			type: 'text',
			text: String(msg),
		},
	],
});

// Report delay
// TODO: calculate days in order production so I can send the dates
// TODO: event for this case also
/*
	pilu_alerta2:
		Alerta de Retraso en Producción
		Este mensaje fue generado porque la orden {{1}} se retrasó {{2}} día(s) en el área de {{3}}. La nueva fecha estimada es {{4}}. Consulte a un supervisor de área.
*/
export const template2 = (number_order, diffDays, area, date) => ({
	templateName: 'pilu_alerta2',
	templateParameters: [
		{
			type: 'text',
			text: String(number_order),
		},
		{
			type: 'text',
			text: String(diffDays),
		},
		{
			type: 'text',
			text: String(area),
		},
		{
			type: 'text',
			text: String(date),
		},
	],
});

// Report new order
/*
	pilu_alerta6:
		Se ha creado un nuevo pedido del cliente *{{1}}*. Con número de orden *{{2}}*. 
		Consulte el panel para revisarlo.
*/
export const template3 = (company_name, number_order) => ({
	templateName: 'pilu_alerta6',
	templateParameters: [
		{
			type: 'text',
			text: String(company_name),
		},
		{
			type: 'text',
			text: String(number_order),
		},
	],
});

// Report order finished
/*
	pilu_alerta7:
		La orden *{{1}}* ha finalizado. Consulte el panel para revisarlo.
*/
export const template4 = (number_order) => ({
	templateName: 'pilu_alerta7',
	templateParameters: [
		{
			type: 'text',
			text: String(number_order),
		},
	],
});

/*
	pilu_alerta8:
		El operador *{{1}}* del área *{{2}}* ha {{3}} el pedido *{{4}}*.
		Consulte el panel para revisarlo.
*/
export const template5 = (user, area, action, order) => ({
	templateName: 'pilu_alerta8',
	templateParameters: [
		{
			type: 'text',
			text: String(user),
		},
		{
			type: 'text',
			text: String(area),
		},
		{
			type: 'text',
			text: String(action),
		},
		{
			type: 'text',
			text: String(order),
		},
	],
});

/*
	template6:
	*Alerta de salida de proceso.* ✅

	*Pedido:* {{1}}.
	*Área completada:* {{2}}.
	*Partida:* {{3}}.
	*Operador:* {{4}}.
*/
export const template6 = (numberOrder, area, bias, user) => ({
	templateName: 'aviso_de_alerta_de_area',
	templateParameters: [
		{
			type: 'text',
			text: String(numberOrder),
		},
		{
			type: 'text',
			text: String(area),
		},
		{
			type: 'text',
			text: String(bias),
		},
		{
			type: 'text',
			text: String(user),
		},
	],
});

/*
	NEW ALERTS for "Mesa de control" & "Logística"

	pilu_alerta8:
		El operador *{{1}}* del área *{{2}}* ha {{3}} el pedido *{{4}}*.
		Consulte el panel para revisarlo.

*/

/*
	{
		"arrRecipients": [
			522226754831
		],
		"templateName": "pilu_alerta5",
		"templateParameters": [
			{
				"type": "text",
				"text": "Benjamín Gutierrez "
			},
			{
				"type": "text",
				"text": "Tela"
			},
			{
				"type": "text",
				"text": "HFJDKE3"
			},
			{
				"type": "text",
				"text": "Hubo un problema con las playeras que me entregaron. Venían manchadas con una tinta negra y ya no sirven para el proceso siguiente."
			}
		]
	}
*/
